export default __webpack_public_path__ + "static/media/arrow_left.9559666e.svg";